import React, { useState, useEffect, useRef, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Card } from "primereact/card";
import { Toast } from "primereact/toast";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { ValuedIcon } from "../../ValuedIcon/index";
import { Button } from "primereact/button";
import EscalaAvaliativaModal from "../../EscalaAvaliativaModal";
import GAS from "../../../GAS";
import "./styles.css";

const Questionarios = (props) => {
  const activeIndex = 0;
  const [questionarios, setQuestionarios] = useState(props.questionarios);
  const [questionariosModelos, setQuestionarioModelos] = useState(
    props.questionariosModelos,
  );
  const [membroCPA, setMembroCPA] = useState(props.membroCPA);
  const [escalasAvaliativa, setEscalasAvaliativas] = useState(
    props.escalasAvaliativa || [],
  );
  const [showEscalaAvaliativaModal, setShowEscalaAvaliativaModal] =
    useState(false);
  const toast = useRef(null);
  const history = useHistory();

  useEffect(() => {
    if (props.questionarios !== questionarios) {
      console.log("Atualizando questionarios:", props.questionarios);
      setQuestionarios(props.questionarios || []);
    }
  }, [props.questionarios, questionarios]);

  useEffect(() => {
    if (
      Array.isArray(props.questionariosModelos) &&
      props.questionariosModelos.length !== questionariosModelos.length
    ) {
      console.log(
        "Atualizando questionariosModelos:",
        props.questionariosModelos,
      );
      setQuestionarioModelos(props.questionariosModelos);
    }
  }, [props.questionariosModelos]);

  useEffect(() => {
    setEscalasAvaliativas(props.escalasAvaliativa || []);
  }, [props.escalasAvaliativa]);

  useEffect(() => {
    setMembroCPA(props.membroCPA || false);
  }, [props.membroCPA]);

  const showMessage = useCallback((type, summary, detail) => {
    if (toast.current) {
      toast.current.show({
        severity: type,
        summary,
        detail,
        life: 8000,
        closable: false,
      });
    }
  }, []);

  const handleEscalaUpdated = useCallback(
    (novaEscalaId) => {
      try {
        console.log("Atualizando escala localmente:", novaEscalaId);

        // Fecha o modal IMEDIATAMENTE
        setShowEscalaAvaliativaModal(false);

        if (!escalasAvaliativa || !Array.isArray(escalasAvaliativa)) {
          console.error("escalasAvaliativa não é um array válido");
          showMessage(
            "error",
            "Erro!",
            "Erro no estado das escalas. Recarregando a página...",
          );

          setTimeout(() => window.location.reload(), 2000);
          return;
        }

        const escalasAtualizadas = escalasAvaliativa.map((escala) => ({
          ...escala,
          default: escala.id === novaEscalaId,
        }));

        console.log("Escalas atualizadas:", escalasAtualizadas);

        setEscalasAvaliativas([...escalasAtualizadas]);

        showMessage(
          "success",
          "Sucesso!",
          "Escala avaliativa padrão atualizada com sucesso.",
        );
      } catch (error) {
        console.error("Erro ao atualizar escala localmente:", error);
        showMessage(
          "error",
          "Erro!",
          "Erro ao atualizar a interface. Recarregando a página...",
        );
        setTimeout(() => window.location.reload(), 5000);
      }
    },
    [
      escalasAvaliativa,
      setShowEscalaAvaliativaModal,
      setEscalasAvaliativas,
      showMessage,
    ],
  );

  const reloadEscalasFromServer = useCallback(() => {
    const gasObj = GAS.getInstance();
    gasObj
      .request("MCPAEscalaAvaliativa.instance.SERVICE.GETescalaAvaliativa")
      .then((RESPONSE) => {
        if (RESPONSE.response && Array.isArray(RESPONSE.data)) {
          setEscalasAvaliativas(RESPONSE.data);
          console.log("Escalas recarregadas do servidor");
        }
      })
      .catch((error) => {
        console.error("Erro ao recarregar escalas do servidor:", error);
      });
  }, []);

  const reloadQuestionariosModelosFromServer = useCallback(() => {
    const gasObj = GAS.getInstance();
    gasObj
      .request(
        "MCPAQuestionario.instance.SERVICE.GETListarModelosQuestionarios",
      )
      .then((RESPONSE) => {
        if (RESPONSE.response && Array.isArray(RESPONSE.data)) {
          setQuestionarioModelos(RESPONSE.data);
          console.log("Questionários modelos recarregados do servidor");
        }
      })
      .catch((error) => {
        console.error(
          "Erro ao recarregar questionários modelos do servidor:",
          error,
        );
        showMessage(
          "error",
          "Erro!",
          "Falha ao recarregar modelos de questionários",
        );
      });
  }, [showMessage]);

  const reloadQuestionariosFromServer = useCallback(() => {
    const gasObj = GAS.getInstance();
    gasObj
      .request(
        "MCPAQuestionario.instance.SERVICE.GETListarQuestionariosParticipante",
        props.usuarioEmail,
      )
      .then((RESPONSE) => {
        if (RESPONSE.response && Array.isArray(RESPONSE.data)) {
          setQuestionarios(RESPONSE.data);
          console.log("Questionários recarregados do servidor");
        }
      })
      .catch((error) => {
        console.error("Erro ao recarregar questionários do servidor:", error);
        showMessage("error", "Erro!", "Falha ao recarregar questionários");
      });
  }, [props.usuarioEmail, showMessage]);

  // Função para recarregar todos os dados do servidor
  const reloadAllDataFromServer = useCallback(() => {
    showMessage(
      "info",
      "Atualizando",
      "Recarregando todos os dados do servidor...",
    );

    reloadEscalasFromServer();
    reloadQuestionariosFromServer();
    reloadQuestionariosModelosFromServer();

    setTimeout(() => {
      showMessage("success", "Concluído", "Dados atualizados com sucesso!");
    }, 2000);
  }, [
    showMessage,
    reloadEscalasFromServer,
    reloadQuestionariosFromServer,
    reloadQuestionariosModelosFromServer,
  ]);

  const deleteQuestionario = useCallback(
    (modelo) => {
      const gasObj = GAS.getInstance();
      gasObj
        .request(
          "MCPAQuestionario.instance.SERVICE.GETDeletarQuestionarioSheets",
          modelo,
        )
        .then((RESPONSE) => {
          if (RESPONSE.response === true) {
            setQuestionarioModelos((prevModelos) =>
              prevModelos.filter((q) => q.id !== modelo.id),
            );

            showMessage(
              "success",
              "Sucesso!",
              "Questionário deletado com sucesso.",
            );
          } else {
            showMessage(
              "error",
              "ERRO!",
              "Não foi possível deletar questionário.",
            );
          }
        })
        .catch((error) => {
          console.error("Erro ao deletar questionário:", error);
          showMessage(
            "error",
            "ERRO!",
            "Não foi possível deletar questionário.",
          );
        });
    },
    [questionariosModelos, showMessage],
  );

  const confirmDelete = useCallback(
    (modelo) => {
      confirmDialog({
        message: "Tem certeza que deseja deletar esse questionário?",
        header: "Confirmação",
        icon: "pi pi-exclamation-triangle",
        rejectLabel: "Não",
        acceptLabel: "Sim",
        accept: () => deleteQuestionario(modelo),
      });
    },
    [deleteQuestionario],
  );

  const contarQuestoes = useCallback((questionario) => {
    let quantidadeQuestoesFechadas = 0;
    let quantidadeQuestoesAbertas = 0;

    if (questionario && questionario.gruposQuestoes) {
      questionario.gruposQuestoes.forEach((grupo) => {
        if (grupo && grupo.questoes) {
          grupo.questoes.forEach((questao) => {
            if (
              questao.tipo === "DIMENSIONALIZADA_FECHADA" &&
              questao.indicadores
            ) {
              quantidadeQuestoesFechadas += questao.indicadores.length;
            } else if (questao.tipo === "DIMENSIONALIZADA_ABERTA") {
              quantidadeQuestoesAbertas++;
            }
          });
        }
      });
    }
    return { quantidadeQuestoesFechadas, quantidadeQuestoesAbertas };
  }, []);

  const renderSemQuestionariosMessage = useCallback(
    () => (
      <p style={{ textAlign: "center" }}>
        <i
          className="pi pi-exclamation-triangle"
          style={{ fontSize: "2em" }}
        ></i>
        <br />
        Não há questionários para você nesta situação
      </p>
    ),
    [],
  );

  const renderQuestionarios = useCallback(
    (disponiveis) => {
      // Render as long as `questionarios` is defined. Use the local `disponiveis` parameter
      // (the function is called with true/false) instead of checking props.disponiveis.
      if (questionarios !== undefined) {
        const questionariosDisponiveis = questionarios.filter((questionario) =>
          disponiveis
            ? !isRespondido(questionario)
            : isRespondido(questionario),
        );

        const questionariosAtivos = questionariosDisponiveis.filter((q) => {
          const agora = new Date();
          return (
            new Date(q.inicioAplicacao) <= agora &&
            agora <= new Date(q.terminoAplicacao)
          );
        });

        const renderSemQuestionarios = (
          disponiveis
            ? questionariosAtivos.length === 0
            : questionariosDisponiveis.length === 0
        )
          ? renderSemQuestionariosMessage()
          : null;

        return (
          <AccordionTab
            header={
              <div className="flex align-items-center">
                <span className="vertical-align-middle">
                  {disponiveis
                    ? "Questionários disponíveis"
                    : "Questionários respondidos"}
                </span>
                {membroCPA && disponiveis && (
                  <div className="button-icon">
                    <Button
                      id="personal-only-icon"
                      icon="pi pi-refresh"
                      title="Recarregar todos os dados do servidor"
                      onClick={reloadAllDataFromServer}
                    />
                    <Button
                      id="personal-only-icon"
                      icon="pi pi-sort-amount-up"
                      title="Alterar escala avaliativa"
                      onClick={() => {
                        if (
                          escalasAvaliativa &&
                          Array.isArray(escalasAvaliativa)
                        ) {
                          setShowEscalaAvaliativaModal(true);
                        } else {
                          showMessage(
                            "warn",
                            "Aguarde",
                            "Escalas avaliativas ainda estão carregando...",
                          );
                        }
                      }}
                    />
                    <Button
                      id="personal-only-icon"
                      icon="pi pi-plus"
                      title="Criar novo questionario"
                      onClick={() => {
                        const escalaDefault = escalasAvaliativa
                          ? escalasAvaliativa.find((escala) => escala.default)
                          : null;
                        const novoQuestionario = {
                          titulo: "",
                          id: "",
                          textoInicial: "",
                          textoFinal: "",
                          periodoLetivo: "",
                          inicioAplicacao: "",
                          terminoAplicacao: "",
                          escala: escalaDefault,
                          filtrosParticipante: {
                            segmento: [],
                            nivelEnsino: [],
                            turno: [],
                          },
                          gruposQuestoes: [
                            { titulo: "", descricao: "", questoes: [] },
                          ],
                        };

                        history.push({
                          pathname: "/gerenciamentoquestionario",
                          state: { questionario: novoQuestionario },
                        });
                      }}
                    />
                  </div>
                )}
              </div>
            }
          >
            {questionariosDisponiveis.map((questionario) => {
              const dataAtual = new Date();
              const inicioAplicacao = new Date(questionario.inicioAplicacao);
              const terminoAplicacao = new Date(questionario.terminoAplicacao);
              const isAtivo =
                inicioAplicacao <= dataAtual && dataAtual <= terminoAplicacao;

              if (disponiveis && !isAtivo) return null;

              return (
                <Card
                  id="card-accordion-question"
                  className={disponiveis ? "disponivel" : "respondido"}
                  key={questionario.id}
                  title={questionario.titulo}
                  subTitle={
                    disponiveis
                      ? `QUESTIONÁRIO DISPONÍVEL ATÉ ${new Date(
                          questionario.terminoAplicacao,
                        ).toLocaleString()}`
                      : `QUESTIONÁRIO RESPONDIDO EM ${new Date(
                          questionario.respondidoEm,
                        ).toLocaleString()}`
                  }
                >
                  <div className="valued-icon" id="quest-Disponivel-Respondido">
                    <div title="Indicadores à responder">
                      <ValuedIcon
                        icon="pi pi-list"
                        value={
                          contarQuestoes(questionario)
                            .quantidadeQuestoesFechadas
                        }
                      />
                    </div>

                    <div id="comente-icon" title="Questões abertas opcionais">
                      <ValuedIcon
                        icon="pi pi-comment"
                        value={
                          contarQuestoes(questionario).quantidadeQuestoesAbertas
                        }
                      />
                    </div>
                  </div>

                  {disponiveis && (
                    <div className="buttons-actions">
                      <Button
                        id="button-card-success"
                        className="p-button-success"
                        label="RESPONDER"
                        icon="pi pi-arrow-right"
                        onClick={() => {
                          history.push({
                            pathname: `/questionario/id/${questionario.id}`,
                            state: { questionario },
                          });
                        }}
                      />
                    </div>
                  )}
                </Card>
              );
            })}
            {renderSemQuestionarios}
          </AccordionTab>
        );
      }
    },
    [
      questionarios,
      membroCPA,
      reloadAllDataFromServer,
      escalasAvaliativa,
      history,
      showMessage,
      contarQuestoes,
      renderSemQuestionariosMessage,
    ],
  );

  const renderModelos = () => {
    // Only render if user is a CPA member
    if (!membroCPA) {
      return null;
    }

    const dataAtual = new Date();
    return (
      <AccordionTab
        header={
          <div className="flex align-items-center">
            <span className="vertical-align-middle">
              Modelos de questionários
            </span>
          </div>
        }
      >
        {questionariosModelos && questionariosModelos.length > 0 ? (
          questionariosModelos.map((modelo) => {
            const { quantidadeQuestoesFechadas, quantidadeQuestoesAbertas } =
              contarQuestoes(modelo);
            const inicioAplicacao = new Date(modelo.inicioAplicacao);
            const terminoAplicacao = new Date(modelo.terminoAplicacao);
            const isAtivo =
              inicioAplicacao <= dataAtual && dataAtual <= terminoAplicacao;
            const descricaoStatus = isAtivo
              ? "Questionário em execução"
              : inicioAplicacao <= dataAtual
                ? "Questionário fora do período"
                : "Questionário em espera";

            return (
              <Card
                id="card-accordion-question"
                className={
                  isAtivo
                    ? "QuestExecucao"
                    : inicioAplicacao <= dataAtual
                      ? "QuestForaPeriodo"
                      : "QuestEspera"
                }
                key={modelo.id}
                title={modelo.titulo}
                subTitle={`QUESTIONÁRIO VAI DE ${new Date(modelo.inicioAplicacao).toLocaleString()} ATÉ ${new Date(modelo.terminoAplicacao).toLocaleString()}`}
              >
                <div
                  style={{
                    backgroundColor: isAtivo
                      ? "#FBC02D"
                      : inicioAplicacao <= dataAtual
                        ? "#d32f2f"
                        : "#4caf50",
                    color: "white",
                    padding: "8px",
                    borderRadius: "4px",
                    width: "fit-content",
                    marginBottom: "20px",
                  }}
                >
                  {descricaoStatus}
                </div>
                <div className="valued-icon">
                  <div title="Indicadores à responder">
                    <ValuedIcon
                      icon="pi pi-list"
                      value={quantidadeQuestoesFechadas}
                    />
                  </div>
                  <div id="comente-icon" title="Questões abertas opcionais">
                    <ValuedIcon
                      icon="pi pi-comment"
                      value={quantidadeQuestoesAbertas}
                    />
                  </div>
                </div>
                <div className="buttons-actions">
                  <Button
                    id="button-card"
                    className="p-button-danger"
                    label="DELETAR"
                    title="Deletar questionário"
                    icon="pi pi-trash"
                    onClick={() => confirmDelete(modelo)}
                  />
                  <Button
                    id="button-card"
                    className="p-button-warning"
                    label="EDITAR"
                    title="Editar questionário"
                    icon="pi pi-pencil"
                    onClick={() => {
                      history.push({
                        pathname: "/gerenciamentoquestionario",
                        state: { questionario: modelo },
                      });
                    }}
                  />
                  <Button
                    id="button-card-copia"
                    className="p-button-primary"
                    label="COPIAR"
                    title="Criar cópia deste questionário"
                    icon="pi pi-clone"
                    onClick={() => {
                      const copiaQuestionario = {
                        ...modelo,
                        titulo: "",
                        id: "",
                        periodoLetivo: "",
                        inicioAplicacao: "",
                        terminoAplicacao: "",
                      };
                      history.push({
                        pathname: "/gerenciamentoquestionario",
                        state: { questionario: copiaQuestionario },
                      });
                    }}
                  />
                </div>
              </Card>
            );
          })
        ) : (
          <p style={{ textAlign: "center" }}>
            <i
              className="pi pi-exclamation-triangle"
              style={{ fontSize: "2em" }}
            ></i>
            <br />
            Nenhum modelo de questionário encontrado
            <br />
            <small style={{ color: "#666" }}>
              Use o botão de atualizar (🔄) no topo da página para recarregar os
              dados
            </small>
          </p>
        )}
      </AccordionTab>
    );
  };

  //console.log(questionarios)
  return (
    <>
      <Toast ref={toast} position="top-left" />
      <ConfirmDialog />
      <div className="questionarios">
        <Accordion activeIndex={activeIndex}>
          {renderQuestionarios(true)}
          {renderQuestionarios(false)}
          {renderModelos()}
        </Accordion>
      </div>
      <EscalaAvaliativaModal
        escalasAvaliativa={escalasAvaliativa}
        visible={showEscalaAvaliativaModal}
        onHide={() => setShowEscalaAvaliativaModal(false)}
        onEscalaUpdated={handleEscalaUpdated}
      />
    </>
  );
};

export const isRespondido = (questionario) => {
  return (
    questionario.respondidoEm !== undefined &&
    questionario.respondidoEm !== null
  );
};

export const isAtivo = (quest) => {
  const dataAgora = new Date()

  return new Date(quest.inicioAplicacao) <= dataAgora && dataAgora <= new Date(quest.terminoAplicacao)

}

export default Questionarios;
